<template>

    <VUEModalCaricamentoDati v-if="PopupCaricamentoDati" :PathGif="require('@/assets/images/CaricamentoDatiGif.gif')"/>
    
    <VUEModal v-if="PopupUdmX" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_TEMP_ASSE_X',this.LinguaUtente)" :Altezza="'80px'" :Larghezza="'500px'" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupUdmX()">
    <template v-slot:Body>
      <div style="display: flex; flex-flow: row wrap; align-items: center; justify-content: space-between; height: 100%; padding-left: 30px; padding-right: 30px;">
        <div style="width: 25%">
          <input class="form-control" type="number" style="margin: 0px; width: 70%;" v-model="ObjGrafico.AxisX.UdmX"/>
        </div>

        <div>
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_GIORNI',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioGiorni" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Giorni" v-model="ObjGrafico.AxisX.TipoUdmX"/>
        </div>

        <div>
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioOre" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Ore" v-model="ObjGrafico.AxisX.TipoUdmX"/>
        </div>

        <div>
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MINUTI',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioMinuti" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Minuti" v-model="ObjGrafico.AxisX.TipoUdmX"/>
        </div>
      </div> 
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupUdmX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjGrafico.UdmX > 0" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupUdmX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupImpostazioniAsseY" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_Y',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupImpostazioniY()">
    <template v-slot:Body>      
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="ObjGrafico.AxisY.Min">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ MixInsGetUnitaDiMisuraAsseYCampRil() }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="ObjGrafico.AxisY.Max">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ MixInsGetUnitaDiMisuraAsseYCampRil() }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="ObjGrafico.AxisY.Udm">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ MixInsGetUnitaDiMisuraAsseYCampRil() }}</p>
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupImpostazioniY" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupImpostazioniY" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupAddRighello" :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_RIGHELLO',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupAddRighello()">
    <template v-slot:Body>
      <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
          <p style="font-weight:bold;width: 120px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_DATA_RIGHELLO',this.LinguaUtente) }}</p>
          <div style="width: 70%; display: flex; justify-content: space-between">
            <input class="form-control" style="width:55%; display: inline" type="date" v-model="ObjNewRighello.Data">
            <input class="form-control" style="width:40%; display: inline" type="time" v-model="ObjNewRighello.Ora">
          </div>
        </div>
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between; margin-top: 10px">
          <p style="font-weight:bold;width: 150px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE_RIGHELLO',this.LinguaUtente) }}</p>
          <label class="form-control" style="width:20%; cursor: pointer; height: 25px; margin: 0px" :style="{'background' : ObjNewRighello.Colore}" @click="ApriPopupColorPicker(ObjNewRighello.Colore, 'background')">&nbsp;</label>
        </div>            
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupAddRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjNewRighello.Data != '' && ObjNewRighello.Ora != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupAddRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupRemoveRighello" :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_RIGHELLO',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupRemoveRighello()">
    <template v-slot:Body>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
        <p style="width: 150px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_SELEZIONA_RIGHELLO',this.LinguaUtente) }}</p>
        <div style="width: 50%; display: flex; justify-content: space-between">
          <select class="form-control" v-model="RighelloToRemove">
            <option :value="''">-</option>
            <option v-for="Righello in ObjGrafico.ListaRighelli" :key="Righello.PrettyDateTime">{{ Righello.PrettyDateTime }}</option>
          </select>
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupRemoveRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="RighelloToRemove != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupRemoveRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEColorPicker :Popup="PopupColorPicker" Programma="DMSEW" :Colore="ColoreInModifica" @OnClickConfermaPopup="ConfermaColore()" @OnClickChiudiPopup="AnnullaColore()"></VUEColorPicker>
  
  <VUEModal v-if="PopupAsseTemp" :Titolo="this.GetTraduzioneLabel('VUEFrameComponenteGraficoStorico','TKN_FRM_GRAF_STORICO_ASSI_IMP',this.LinguaUtente)" :Altezza="'150px'" :Larghezza="'500px'" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupAsseTemp" @onClickConfermaModal="ConfermaPopupAsseTemp">
    <template v-slot:Body>
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="ObjGrafico.AxisYTemp.Min">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">[{{ this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) }}]</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="ObjGrafico.AxisYTemp.Max">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">[{{ this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) }}]</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.01" v-model="ObjGrafico.AxisYTemp.Ampiezza">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">[{{ this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) }}]</p>
        </div>
      </div>
    </template>
  </VUEModal>
  
  <div style="min-height:500px;">

    <div class="ZMSeparatoreScheda" style="margin-bottom:10px;margin-top:5px" :style="{'background-color' : ColoriPantone.Marrone }">       
      <text style="font-weight: bold;">{{this.GetTraduzioneLabel('Generic','TKN_MOD_NR',this.LinguaUtente) + Modulo.Id + ' ' + 
                                         (CurrentIsEstensimetro ? (this.GetTraduzioneLabel('Generic','TKN_ESTENSIONI',this.LinguaUtente)) : 
                                                                  (IsPiezometro ? (this.GetTraduzioneLabel('Generic','TKN_PIEZOMETRO',this.LinguaUtente)) : 
                                                                                  (this.GetTraduzioneLabel('Generic','TKN_INCLINAZIONI',this.LinguaUtente))
                                                                  )
                                          ) 
                                          + ' - ' + 
                                          (IsPiezometro ? this.GetTraduzioneLabel('Generic','TKN_PROFONDITA',this.LinguaUtente) :
                                                          this.GetTraduzioneLabel('Generic','TKN_PROFONDITA_DA',this.LinguaUtente) + ' ' + Number(Modulo.Profondita) + ' ' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_PIANO_CAMPAGNA',this.LinguaUtente) + ' ' + this.GetTraduzioneLabel('Generic','TKN_LETT_A',this.LinguaUtente))
                                           + ' ' + Number(Modulo.Profondita + Modulo.Lunghezza) + ' ' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_PIANO_CAMPAGNA',this.LinguaUtente) }}</text>
    </div>
    <div style="width:89%;float:left" ref="DivCanvas">

      <VUEComponenteGraficoCampioniRilevati :WidthGrafico="GrandezzaCanvas.Width" 
                                            :HeightGrafico="GrandezzaCanvas.Height"
                                            :Modulo="Modulo"
                                            :ObjDal="ObjDal"
                                            :ObjAl="ObjAl"
                                            :TipoGrafico="TipoGrafico"
                                            :PropsGrafico="ObjGrafico"
                                            :Repaint="Repaint"
                                            :GraficiChange="GraficiChange"
                                            :PressAdatta="PressAdatta"
                                            :IsPiezometro="CurrentIsPiezometro"
                                            :IsEstensimetro="CurrentIsEstensimetro"
                                            :ShowHintRoll="ObjGrafico.Roll"
                                            :ShowHintPitch="ObjGrafico.Pitch"
                                            :ShowHintTemp="ObjGrafico.Temp"
                                            :VisualizzaMarkup="VisualizzaMarkup"/>
    </div>
    
    <div style="height: 500px" ref="DivButtons">
      <div style="width:9%;float:right; margin-right: 10px; margin-top: 16px;">
        <div style="margin-top:5px">
          <div v-if="!CurrentIsPiezometro && !CurrentIsEstensimetro">
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:92%;">

              <div style="float:left;width:10%;">
                <input style="float:left;height:100%" v-model="ObjGrafico.Pitch" @change="Repaint++" type="checkbox" class="form-control"/>
              </div>
              <div style="float:left;width:90%;">
                <label style="float:left;color:purple;font-size:14px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('Generic','TKN_PITCH',this.LinguaUtente) }}</label>
              </div>
              <div style="clear:both"></div>

              <div style="float:left;width:10%;">
                <input style="float:left;height:100%" v-model="ObjGrafico.Roll" @change="Repaint++" type="checkbox" class="form-control"/>
              </div>
              <div style="float:left;width:90%;">
                <label style="float:left;color:green;font-size:14px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('Generic','TKN_ROLL',this.LinguaUtente) }}</label>
              </div>
            </div>
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="clear:both"></div>
          </div>

          <div v-if="CurrentIsPiezometro">
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:92%;">
              <div style="float:left;width:10%;">
              </div>
              <div style="float:left;width:90%;">
                <label style="color: blue;float:left;font-size:14px;margin-bottom:4px">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStorico','TKN_FRM_GRAF_STORICO_LV_FALDA',this.LinguaUtente) }}</label>
              </div> 
              <div style="clear:both;height:1px"></div>
              <div style="float:left;width:5%;">
              </div>
            </div>
            <div style="clear:both"></div>
          </div>

          <div v-if="CurrentIsEstensimetro">
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:92%;">
              <div style="float:left;width:10%;">
              </div>
              <div style="float:left;width:90%;">
                <label style="color: brown;float:left;font-size:14px;margin-bottom:4px">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStorico','TKN_FRM_GRAF_STORICO_EST',this.LinguaUtente) }}</label>
              </div>
              <div style="clear:both;height:1px"></div>
              <div style="float:left;width:5%;">
              </div>
            </div>
            <div style="clear:both"></div>
          </div>

          <div>
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:92%;">
              <div style="float:left;width:10%;">
                <input style="float:left;height:100%" type="checkbox" @change="Repaint++" class="form-control" v-model="ObjGrafico.Temp"/>
              </div> 
              <div style="float:left;width:90%;">
                <label style="float:left;color:red;font-size:14px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) }}</label>
              </div> 
            </div>
            <div style="float:left;width:4%;">&nbsp;</div>
            
            <div style="clear:both;height:10px"></div>
          </div>

          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button type="button" class="btn btn-info" @click="OnClickAdatta" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_ADATTA',this.LinguaUtente) }}</button>
          </div>
          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="clear:both;height:4px"></div>

          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button type="button" class="btn btn-info" @click="OnClickUdmX" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_ASSE_X',this.LinguaUtente) }}</button>
          </div>
          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="clear:both;height:4px"></div>

          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button type="button" class="btn btn-info" @click="ApriPopupImpostazioniY" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_ASSE_Y',this.LinguaUtente) }}</button>
          </div>
          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="clear:both;height:4px"></div>

          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button type="button" class="btn btn-info" @click="OnClickAsseTemp" style="width:100%">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoStorico','TKN_FRM_GRAF_STORICO_ASSE_TEMP',this.LinguaUtente) }}</button>
          </div>
          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="clear:both;height:4px"></div>

          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button type="button" class="btn btn-info" @click="ApriPopupAddRighello" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_ADD_RIGHELLO',this.LinguaUtente) }}</button>
          </div>
          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="clear:both;height:4px"></div>

          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button :disabled="ObjGrafico.ListaRighelli.length == 0" type="button" class="btn btn-info" @click="ApriPopupRemoveRighello()" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_DEL_RIGHELLO',this.LinguaUtente) }}</button>
          </div>
          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="clear:both;height:15px"></div>

          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button type="button" class="btn btn-info" @click="EsportaComePDF()" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente) }}</button>
          </div>
          <div style="float:left;width:2%;">&nbsp;</div>
          <div style="clear:both;height:4px"></div>
        
        </div>   
        <div style="float:left;">&nbsp;</div>
      </div>
    </div>
  </div>
  <div style="clear:both"></div>

</template>

<script>
import { COLORI_PANTONE, TIPI_UDM_X, SystemInformation } from '@/SystemInformation'
import VUEComponenteGraficoCampioniRilevati from '../Slots/VUEComponenteGraficoCampioniRilevati.vue'
// import { TZMathFunct } from '@/utils/ZMathFunct'
// import { TZDateFunct } from '@/utils/ZDateFunct'
import VUEModal from '@/utils/VUEModal.vue'
import VUEColorPicker from '@/utils/VUEColorPicker.vue'
// import { TZMathFunct } from '@/utils/ZMathFunct'
import { TZGenericFunct } from '@/utils/ZGenericFunct'
import VUEModalCaricamentoDati from '@/utils/VUEModalCaricamentoDati.vue'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import MixInsDoubleClickHandler from '@/views/ContentPages/MixInsDoubleClickHandler'
import MixInsGraficiStorici from '@/views/ContentPages/MixInsGraficiStorici'

export default 
{
  data()
  {
   return {
            ColoriPantone         : COLORI_PANTONE,
            TipiUdmX              : TIPI_UDM_X,
            TipoUdmX              : 0,
            GrandezzaCanvas       : {
                                      Width  : 0,
                                      Height : 0
                                    },
            ObjGrafico            : {
                                      Pitch  : true,
                                      Roll   : true,
                                      Temp   : true,
                                      AxisY  : {
                                                  Min : 0,
                                                  Max : 0,
                                                  Udm : 0,
                                                  Modificato : false,
                                               },
                                      AxisYTemp : {
                                                    Min        : 0.0,
                                                    Max        : 30.0,
                                                    Ampiezza   : 5.00,
                                                    Modificato : false
                                                  }
                                    },
            PopupUdmX              : false,
            PopupAsseTemp          : false,
            Repaint                : 0,
            PressAdatta            : 0,
            PopupImpostazioniAsseY : false,
            PopupAddRighello       : false,
            PopupRemoveRighello    : false,
            PopupColorPicker       : false,
            ColoreInModifica       : { Colore: '#000000' },
            ObjNewRighello         : { Data: '', Ora : '', PrettyDateTime: '', Colore: '#000000' },
            RighelloToRemove       : '',
            LinguaUtente           : SystemInformation.UserInformation.Lingua,
            PopupCaricamentoDati   : false
          }
  },

  props : ['Modulo', 'ObjDal', 'ObjAl', 'TipoGrafico', 'GraficiChange', 'IsPiezometro', 'IsEstensimetro', 'VisualizzaMarkup', 'ParametriPDF', 'GetDatiPDF'],
  emits : ['EsportaPDFGrafico'],
  mixins: [MixInsDoubleClickHandler, MixInsGestioneTraduzioni, MixInsGraficiStorici],
  components: { 
                VUEComponenteGraficoCampioniRilevati,
                VUEModal,
                VUEModalCaricamentoDati,
                VUEColorPicker
              },

  methods :
  {
    CalcolaGrandezzaDivCanvas()
    {
      this.Repaint++
      this.GrandezzaCanvas.Width  = this.$refs.DivCanvas.clientWidth 
      this.GrandezzaCanvas.Height = this.$refs.DivButtons.clientHeight
    },

    OnClickAdatta()
    {
      this.MixInsOnClickAdattaCampRil(this.ObjGrafico)
    },  

    EsportaComePDF()
    {
      this.$emit('EsportaPDFGrafico', this.Modulo.Id, this.IsPiezometro, this.IsEstensimetro)
    },

    GetGraficiPDF()
    {
      if(!this.ObjPDF.PDFModulo)
        this.ObjPDF.PDFModulo = []

      if(!this.ObjPDF.PDFObjDatiGrafici)
        this.ObjPDF.PDFObjDatiGrafici = []
      
      let ModuloPDF = TZGenericFunct.GetCopyOfObject(this.Modulo)
      ModuloPDF.IsPiezometro = this.IsPiezometro
      ModuloPDF.IsEstensimetro = this.IsEstensimetro
      ModuloPDF.ShowRoll = this.ObjGrafico.Roll
      ModuloPDF.ShowPitch = this.ObjGrafico.Pitch
      ModuloPDF.ShowTemp = this.ObjGrafico.Temp

      let ArrayOggettoGrafico = TZGenericFunct.GetCopyOfObject(this.ObjGrafico.OggettoGrafico)
      
      if(ArrayOggettoGrafico.OtherAxis != undefined && ArrayOggettoGrafico.OtherAxis.length > 0)
      {
        ArrayOggettoGrafico.OtherAxis.forEach(AsseAlternativa => { AsseAlternativa.LabelOnGraph = true });
      }

      this.ObjPDF.PDFModulo.push(ModuloPDF)
      this.ObjPDF.PDFObjDatiGrafici.push(ArrayOggettoGrafico)
    },

    OnClickUdmX()
    {
      this.PopupUdmX = true
    },

    ConfermaPopupUdmX()
    {
      this.MixInsConfermaPopupUdmXCampRil(this.ObjGrafico)
    },

    AnnullaPopupUdmX()
    {
      this.PopupUdmX = false
    },

    OnClickAsseTemp()
    {
      this.PopupAsseTemp = true
    },

    AnnullaPopupAsseTemp()
    {
      this.PopupAsseTemp = false
    },

    ConfermaPopupAsseTemp()
    {
      this.MixInsConfermaPopupAsseTemp(this.ObjGrafico)
    },

    ApriPopupImpostazioniY()
    {
      this.PopupImpostazioniAsseY = true
    },

    ConfermaPopupImpostazioniY()
    {
      this.MixInsConfermaPopupImpostazioniYCampRil(this.ObjGrafico)
    },

    AnnullaPopupImpostazioniY()
    {
      this.MixInsAnnullaPopupImpostazioniYCampRil(this.ObjGrafico)
    },

    ApriPopupAddRighello()
    {
      this.PopupAddRighello = true
    },

    ConfermaPopupAddRighello()
    {
      this.MixInsConfermaPopupAddRighelloCampRil(this.ObjGrafico)
    },

    AnnullaPopupAddRighello()
    {
      this.PopupAddRighello = false
      this.MixInsResetNewRighelloCampRil()
    },

    ApriPopupRemoveRighello()
    {
      this.RighelloToRemove = ''
      this.PopupRemoveRighello = true
    },

    ConfermaPopupRemoveRighello()
    {
      this.MixInsConfermaPopupRemoveRighelloCampRil(this.ObjGrafico)
    },

    AnnullaPopupRemoveRighello()
    {
      this.PopupRemoveRighello = false
    },

    ApriPopupColorPicker(Colore)
    {
      this.ColoreInModifica.Colore = Colore
      this.PopupColorPicker = true
    },

    ConfermaColore()
    {
      this.ObjNewRighello.Colore = this.ColoreInModifica.Colore
      this.AnnullaColore()
    },

    AnnullaColore()
    {
      this.ColoreInModifica = {}
      this.PopupColorPicker = false
    }
  },

  watch:
  {
    GetDatiPDF :
    {
      handler(NewValue)
      {
        if (NewValue != 0)
          this.GetGraficiPDF()
      }
    },

    GraficiChange:
    {
      handler()
      {
        if(this.OggettoTotaleSpostamento != undefined)
        {
          if(this.OggettoTotaleSpostamento.ModificatoAsseX)
          { 
            this.ObjGrafico.AxisX.Modificato = this.OggettoTotaleSpostamento.ModificatoAsseX
            this.ObjGrafico.AxisX.UdmX       = this.OggettoTotaleSpostamento.AdattaUdmX
            this.ObjGrafico.AxisX.TipoUdmX   = this.OggettoTotaleSpostamento.AdattaTipoUdmX
            this.Repaint++
          }
        }

        if(this.CurrentModulo != undefined)
        {
          if(this.CurrentModulo.ModificatoAsseX)
          {
            this.ObjGrafico.AxisX.Modificato = this.CurrentModulo.ModificatoAsseX
            this.ObjGrafico.AxisX.UdmX       = this.CurrentModulo.AdattaUdmX
            this.ObjGrafico.AxisX.TipoUdmX   = this.CurrentModulo.AdattaTipoUdmX
            this.Repaint++
          }
        }
      }
    }
  },
  
  computed:
  {
    CurrentModulo :
    {
      get()
      {
        return this.Modulo
      }
    },

    CurrentIsPiezometro :
    {
      get()
      {
        return this.IsPiezometro
      }
    },

    CurrentIsEstensimetro :
    {
      get()
      {
        return this.IsEstensimetro
      }
    },

    ObjPDF :
    {
      get()
      {
        return this.ParametriPDF
      }
    }
  },

  mounted()
  {
    this.CalcolaGrandezzaDivCanvas()
    window.addEventListener('resize', this.CalcolaGrandezzaDivCanvas)
  },
  
  beforeMount()
  {
    // this.OnClickAdatta()
    this.MixInsSetObjGraficoCampRil(this.ObjGrafico, this.CurrentModulo)
  },
  
  beforeUnmount()
  {
    window.removeEventListener('resize', this.CalcolaGrandezzaDivCanvas)
  }
}
</script>